export default {
  listCommit (state, data) {
    state.chat = data
  },
  videoCallCommit (state, data) {
    state.videoCall = data
  }
}
